import omniTab from './omniTab';
import tabBar from './tabBar';
export { omniTab, tabBar };



// WEBPACK FOOTER //
// ./src/components/tabBar/index.js